import React, { useState } from 'react';
export default BibleStore;
const BIBLE_PRODUCTS = [
  {
    id: 1,
    title: "ESV Study Bible",
    author: "Crossway",
    price: 49.99,
    originalPrice: 59.99,
    image: "/api/placeholder/200/280",
    rating: 4.9,
    reviews: 2847,
    description: "The ESV Study Bible was created to help people understand the Bible in a deeper way.",
    category: "Study Bibles",
    format: "Hardcover",
    pages: 2752,
    features: ["Cross-references", "Study notes", "Maps", "Charts"]
  },
  {
    id: 2,
    title: "NIV Life Application Study Bible",
    author: "Tyndale House Publishers",
    price: 39.99,
    originalPrice: 49.99,
    image: "/api/placeholder/200/280",
    rating: 4.8,
    reviews: 1923,
    description: "Trusted & Treasured by Millions of Readers over 30 years.",
    category: "Study Bibles",
    format: "Leather Bound",
    pages: 2480,
    features: ["Life application notes", "Character profiles", "Maps"]
  },
  {
    id: 3,
    title: "The MacArthur Study Bible",
    author: "John MacArthur",
    price: 44.99,
    originalPrice: 54.99,
    image: "/api/placeholder/200/280",
    rating: 4.7,
    reviews: 1456,
    description: "Unleashing God's Truth One Verse at a Time.",
    category: "Study Bibles",
    format: "Hardcover",
    pages: 2400,
    features: ["25,000 study notes", "Maps", "Charts", "Introductions"]
  },
  {
    id: 4,
    title: "Strong's Exhaustive Concordance",
    author: "James Strong",
    price: 24.99,
    originalPrice: 29.99,
    image: "/api/placeholder/200/280",
    rating: 4.6,
    reviews: 892,
    description: "The most complete, easy-to-use, and understandable concordance.",
    category: "Reference",
    format: "Paperback",
    pages: 1840,
    features: ["Hebrew & Greek dictionaries", "Word studies", "Cross-references"]
  },
  {
    id: 5,
    title: "Vine's Complete Expository Dictionary",
    author: "W.E. Vine",
    price: 19.99,
    originalPrice: 24.99,
    image: "/api/placeholder/200/280",
    rating: 4.5,
    reviews: 634,
    description: "Old and New Testament Words with their Precise Meanings.",
    category: "Reference",
    format: "Paperback",
    pages: 1184,
    features: ["Word definitions", "Etymology", "Usage examples"]
  },
  {
    id: 6,
    title: "Matthew Henry's Commentary",
    author: "Matthew Henry",
    price: 34.99,
    originalPrice: 42.99,
    image: "/api/placeholder/200/280",
    rating: 4.8,
    reviews: 1247,
    description: "Complete commentary on the whole Bible in one volume.",
    category: "Commentaries",
    format: "Hardcover",
    pages: 2496,
    features: ["Verse-by-verse commentary", "Practical applications", "Cross-references"]
  }
];

const CATEGORIES = [
  "All Products",
  "Study Bibles", 
  "Commentaries",
  "Reference",
  "Devotionals",
  "Theology",
  "Biblical Studies"
];

function BibleStore({ onBack }) {
  const [selectedCategory, setSelectedCategory] = useState("All Products");
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Filter products based on category and search
  const filteredProducts = BIBLE_PRODUCTS.filter(product => {
    const matchesCategory = selectedCategory === "All Products" || product.category === selectedCategory;
    const matchesSearch = product.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         product.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Add to cart
  const addToCart = (product) => {
    const existingItem = cart.find(item => item.id === product.id);
    if (existingItem) {
      setCart(cart.map(item => 
        item.id === product.id 
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  };

  // Remove from cart
  const removeFromCart = (productId) => {
    setCart(cart.filter(item => item.id !== productId));
  };

  // Update quantity
  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity === 0) {
      removeFromCart(productId);
    } else {
      setCart(cart.map(item => 
        item.id === productId 
          ? { ...item, quantity: newQuantity }
          : item
      ));
    }
  };

  // Calculate total
  const cartTotal = cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Store Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-4">
              <button
                onClick={onBack}
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                ← Back to Bible
              </button>
              <h1 className="text-2xl font-bold text-gray-900">Dominion Kingdom Store</h1>
            </div>
            {/* ...existing code... */}
export default BibleStore;
          </div>
        </div>
      </div>
      {/* ...existing code... */}
    </div>
  );
}

